import script from "./BaseSettingLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSettingLayout.vue?vue&type=script&setup=true&lang=js"

import "./BaseSettingLayout.vue?vue&type=style&index=0&id=665ae893&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-665ae893"]])

export default __exports__